import React, { createContext, ReactElement, useContext } from 'react';

import { IParentProps } from '../../shared/types/IParentProps';

export type IModalContextValue = {
    hideModal: () => void;
};

export const OzModalContext = createContext<IModalContextValue | undefined>(undefined);

type IModalProvider = IParentProps & {
    hideModal: () => void;
};

export function OzModalProvider (props: IModalProvider): ReactElement {
    const { children, hideModal }: IModalProvider = props;

    const contextValue: IModalContextValue = {
        hideModal,
    };

    return (
        <OzModalContext.Provider value={contextValue}>
            {children}
        </OzModalContext.Provider>
    );
}

export function useModalContext (): IModalContextValue {
    const context: IModalContextValue | undefined = useContext(OzModalContext);

    if (context === undefined) {
        throw new Error('useModalContext must be used within a OzModalProvider');
    }

    return context;
}
